export const CREATE_TESTRIDE_APPOINTMENT_REQUEST = 'CREATE_TESTRIDE_APPOINTMENT_REQUEST'
export const CREATE_TESTRIDE_APPOINTMENT_SUCCESS = 'CREATE_TESTRIDE_APPOINTMENT_SUCCESS'
export const CREATE_TESTRIDE_APPOINTMENT_FAIL = 'CREATE_TESTRIDE_APPOINTMENT_FAIL'
